import { render, staticRenderFns } from "./editProfile.vue?vue&type=template&id=41011924&"
import script from "./editProfile.vue?vue&type=script&lang=js&"
export * from "./editProfile.vue?vue&type=script&lang=js&"
import style0 from "./editProfile.vue?vue&type=style&index=0&id=41011924&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports